/**
 * Returns internal path (pathname + search + hash) only when the URL matches
 * `currentOrigin`. Mitigates open redirects (other host, //evil.com, etc.).
 */
export function getSafeSameOriginReturnPath(
  returnToRaw: string | null,
  currentOrigin: string
): string | null {
  if (!returnToRaw || typeof returnToRaw !== "string") {
    return null;
  }
  let decoded = returnToRaw.trim();
  try {
    decoded = decodeURIComponent(decoded);
  } catch {
    return null;
  }
  if (!decoded) {
    return null;
  }
  let u: URL;
  try {
    u = new URL(decoded, currentOrigin);
  } catch {
    return null;
  }
  if (u.protocol !== "http:" && u.protocol !== "https:") {
    return null;
  }
  if (u.origin !== currentOrigin) {
    return null;
  }
  return `${u.pathname}${u.search}${u.hash}`;
}

export function getSafeSameOriginReturnPathFromSearch(
  search: string,
  currentOrigin: string
): string | null {
  const params = new URLSearchParams(
    search.startsWith("?") ? search.slice(1) : search
  );
  return getSafeSameOriginReturnPath(params.get("returnTo"), currentOrigin);
}
